module.exports = __webpack_public_path__ + "img/carrousel-rad-conv-3.a799afcd.png";